import { useEffect } from 'react'
import App from './app/App'
import moment from 'moment'
import { Provider } from 'react-redux'
import { sharedStore, UserHelper } from '@Techedge/digitalportal-shared'
import newActivityReducer, {
    NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE,
} from './app/redux/reducers/activity-creation'
import filtersReducer, { FILTERS_REDUCER_NAMESPACE } from './app/redux/reducers/filters'
import newActivityExecutionReducer, {
    NEW_ACTIVITY_EXECUTION_NAMESPACE,
} from './app/redux/reducers/activity-execution'
import newActivityApprovalReducer, {
    NEW_ACTIVITY_APPROVAL_REDUCER_NAMESPACE,
} from './app/redux/reducers/activity-approval'
import newResourceReducer, {
    NEW_RESOURCE_REDUCER_NAMESPACE,
} from './app/redux/reducers/new-resource'
import newForumReducer, { NEW_FORUM_REDUCER_NAMESPACE } from './app/redux/reducers/new-forum'
import savePictureReducer, {
    SAVE_PICTURE_REDUCER_NAMESPACE,
} from './app/redux/reducers/save-picture'
import quickLinkReducer, {QUICK_LINK_REDUCER_NAMESPACE} from "@redux/reducers/quick-link";
import distributionReducer, {DISTRIBUTION_REDUCER_NAMESPACE} from "@redux/reducers/distribution"

export const locale = UserHelper?._shared()?.user()?.language || 'en-US'

export const dateFormat = moment
    .localeData(locale)
    .longDateFormat('L')
    .toLocaleLowerCase()
    .replace('yyyy', 'yy')

export default function Root(props: any) {
    useEffect(() => {
        sharedStore.injectReducer(NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE, newActivityReducer)
        sharedStore.injectReducer(FILTERS_REDUCER_NAMESPACE, filtersReducer)
        sharedStore.injectReducer(NEW_ACTIVITY_EXECUTION_NAMESPACE, newActivityExecutionReducer)
        sharedStore.injectReducer(
            NEW_ACTIVITY_APPROVAL_REDUCER_NAMESPACE,
            newActivityApprovalReducer
        )
        sharedStore.injectReducer(NEW_RESOURCE_REDUCER_NAMESPACE, newResourceReducer)
        sharedStore.injectReducer(NEW_FORUM_REDUCER_NAMESPACE, newForumReducer)
        sharedStore.injectReducer(SAVE_PICTURE_REDUCER_NAMESPACE, savePictureReducer)
        sharedStore.injectReducer(QUICK_LINK_REDUCER_NAMESPACE, quickLinkReducer)
        sharedStore.injectReducer(DISTRIBUTION_REDUCER_NAMESPACE, distributionReducer)
    }, [])

    return (
        <Provider store={sharedStore}>
            <App {...props} />
        </Provider>
    )
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
